import type { ShopQueueItemDto } from "@grizzly/shared";
import { operationStatus, taskPriority } from "@grizzly/shared";
import { Badge } from "../ui/badge.js";
import { cn } from "../../lib/cn.js";
import { useI18n, type MessageKey } from "../../i18n/index.js";

export function QueueList({
  items,
  selectedId,
  onSelect,
}: {
  items: ShopQueueItemDto[];
  selectedId: string | null;
  onSelect(operationId: string): void;
}) {
  const { t } = useI18n();
  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item.operationId}>
          <button
            type="button"
            onClick={() => onSelect(item.operationId)}
            className={cn(
              "w-full rounded-[var(--radius-card)] border px-3 py-2 text-start",
              selectedId === item.operationId
                ? "border-action-primary bg-action-primary/10"
                : "border-line bg-surface-raised hover:border-line-strong"
            )}
          >
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-semibold text-ink">
                {item.jobNumber} · {item.operationDescription}
              </p>
              <Badge tone={operationStatus(item.status).tone}>
                {t(`status.operation.${item.status}` as MessageKey)}
              </Badge>
            </div>
            <p className="mt-0.5 text-xs text-ink-muted">
              {item.jobTitle} · {item.workCenterName ?? t("shopFloor.noWorkCenter")}
              {item.dueDate ? ` · ${t("shopFloor.dueAt", { date: item.dueDate })}` : ""}
              {item.priority === "high" ? (
                <Badge tone={taskPriority(item.priority).tone}>
                  {t("status.priority.high")}
                </Badge>
              ) : null}
            </p>
          </button>
        </li>
      ))}
    </ul>
  );
}
